import { render, staticRenderFns } from "./VideoCreateInfo.vue?vue&type=template&id=8dc0b286&"
import script from "./VideoCreateInfo.vue?vue&type=script&lang=js&"
export * from "./VideoCreateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports